import { BaseAPI } from './base_api';
import { ApiResponse, UserWithAppVersion } from '@clef/shared/types';
class ProfileAPI extends BaseAPI {
  async getProfile(): Promise<ApiResponse<UserWithAppVersion>> {
    return this.get('fetch_profile', undefined, false);
  }
}

export default new ProfileAPI('');
